interface SocialButtonProps {
    link: string;
    icon: string;
    alt: string;
}

export default function SocialButton(props: SocialButtonProps) {
    return (
        <a href={props.link} className="social-button" target="blank" rel="noopener noreferrer">
            <img src={props.icon} alt={props.alt} />
        </a>
    )
}